import { render, staticRenderFns } from "./OrderDetailModal.vue?vue&type=template&id=4e583dcd&scoped=true&"
import script from "./OrderDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailModal.vue?vue&type=style&index=0&id=4e583dcd&lang=scss&scoped=true&"
import style1 from "./OrderDetailModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e583dcd",
  null
  
)

export default component.exports